import { FC } from 'react';
import { useI18n } from 'contexts/i18n';
import { PriceColumnProps, Styled } from '.';

const PriceColumn: FC<PriceColumnProps> = ({
  subtotal,
  netTotal,
  showDiscount,
}) => {
  const i18n = useI18n();

  if (!showDiscount) {
    return (
      <Styled.PriceColumnContainer data-testid="price-column-container">
        <Styled.NetTotal
          $hasDiscount={false}
          data-testid="price-column-net-total"
        >
          {netTotal}
        </Styled.NetTotal>
      </Styled.PriceColumnContainer>
    );
  }

  return (
    <Styled.PriceColumnContainer data-testid="price-column-container">
      <Styled.NetTotal $hasDiscount={true} data-testid="price-column-net-total">
        {netTotal}
      </Styled.NetTotal>
      <Styled.SubTotal data-testid="price-column-subtotal">
        {subtotal}
      </Styled.SubTotal>
    </Styled.PriceColumnContainer>
  );
};

export default PriceColumn;
